import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.data('toc', () => ({
    headings: [],
    activeId: null,

    init() {
        const content = document.querySelector('.doc-content')
        if (!content) return

        this.headings = Array.from(content.querySelectorAll('h2, h3')).map(el => {
            if (!el.id) {
                el.id = el.textContent
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9]+/g, '-')
                    .replace(/^-|-$/g, '')
            }
            return {
                id: el.id,
                text: el.textContent.trim(),
                level: parseInt(el.tagName[1]),
            }
        })

        if (this.headings.length === 0) return

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.activeId = entry.target.id
                    }
                })
            },
            { rootMargin: '-10% 0% -75% 0%' }
        )

        this.headings.forEach(h => {
            const el = document.getElementById(h.id)
            if (el) observer.observe(el)
        })
    },
}))

Alpine.start()
